Whether the draft created is ready to be posted to SEEK.
